module.exports = __webpack_public_path__ + "media/images/logo-bf3a34cce8835ae6094c1434bb61211a.svg";